import { useState } from 'react'

import {
  CustomizationField,
  fieldOptions,
  isMileageRate,
  isPaymentMethod,
} from 'modules/expenses/hooks/useExpensesCustomization'
import { FieldOptions } from 'modules/expenses/lib/types'

import usePaymentMethodOptions from './usePaymentMethodOptions'
import useRateOptions from './useRateOptions'

const useField = (field: CustomizationField, parent?: string) => {
  const [mandatory, setMandatory] = useState<boolean>(field.mandatory)

  const mileageRateOptions = useRateOptions(field)
  const paymentMethodOptions = usePaymentMethodOptions(field, parent)

  const options: FieldOptions = (() => {
    if (isMileageRate(field)) return mileageRateOptions
    if (isPaymentMethod(field)) return paymentMethodOptions

    const options = fieldOptions(field)
    return { value: options, set: () => null, normalized: options, valid: true }
  })()

  return { field, options, mandatory: { value: mandatory, set: setMandatory } }
}

export default useField
